<template>
<div id="app" class="viewport" v-bind:class="(!$device.windows)? 'mob': ''">

	<!-- div class="popArea">
		<a href="javascript:void(0)" class="moveIr"><img src="@/assets/images/popupGnm.jpg" class="합병으로 인한 채권자 이의 제출공고" /></a>
		<span class="close"><em></em><em></em></span>
	</!-->


	<header class="head">
		<h1 class="logo" v-on:click="go(1)"><a href="#;"><img src="@/assets/images/logo.png" alt="logo"></a></h1>
		<v-touch @swiperight="menuToggle" class="navList" v-bind:class="(!$device.windows)? 'mo': ''">
			<ul class="gnb">
				<li class="no1 active" v-on:click="go(1)"><a href="#;">Introduction</a></li>
				<li class="no2" v-on:click="go(2)"><a href="#;">Vision</a></li>
				<li class="no3" v-on:click="go(3)"><a href="#;">Feature</a></li>
				<li class="no4" v-on:click="go(4)"><a href="#;">Client</a></li>
				<li class="no5" v-on:click="go(5)"><a href="#;">Recruit</a></li>
				<!-- <li class="no7" v-on:click="go(7)"><a href="#;">IR</a></li> -->
				<li class="no6" v-on:click="go(6)"><a href="#;">Contact</a></li>
			</ul>
		</v-touch>
		<div class="mo btnMenu" v-on:click="menuToggle"><a href="#;"></a></div>
	</header>
	<div class="container">
		<div class="contents">

			<!-- section01 -->
			<div class="section sec01 current" id="section01">
				<div class="contentWrap gnbGo">
					
					<div class="mainVs">
						<div class="img"></div>
						<ul class="udList">
							<li class="no1"><img src="@/assets/images/ud_01.png" alt="동그라미"></li>
							<li class="no2"><img src="@/assets/images/ud_02.png" alt="동그라미"></li>
							<li class="no3"><img src="@/assets/images/ud_03.png" alt="동그라미"></li>
							<li class="no4"><img src="@/assets/images/ud_04.png" alt="네모"></li>
							<li class="no5"><img src="@/assets/images/ud_05.png" alt="네모"></li>
						</ul>
						<ul class="sqList">
							<li class="no1"><span></span></li>
							<li class="no2 ani"></li>
							<li class="no3 ani"></li>
						</ul>
					</div>
					
					<div class="introWrap">

						<div class="introTitle">
							<h2 class="title">
								GnM <span class="fontRL">performance</span>
								<span class="slogan">Get the Most valuable Performance</span>
							</h2>
							<div class="text">
								GnM performance는 퍼포먼스 마케팅<br class="mo2"> 전문 브랜드 입니다. <br>
								그랑몬스터와 메큐라이크, 그리고 관계사들이 <br class="mo">퍼포먼스 마케팅 역량을 하나의 브랜드로 담았습니다.
							</div>
						</div>

		
						<!-- <div class="introImg"></div> -->

						<div class="introBox">
							<ul class="companyList">
							</ul>
						</div>
		
					</div>

					<div class="scroll" v-on:click="go(2)">
						<a href="#;">Scroll down</a>
					</div>

				</div>
			</div>
			<!-- //section01 -->

			<!-- section02 -->
			<div class="section sec02" id="section02">
				<div class="contentWrap gnbGo">

					<div class="visionWrap">
						<div class="visionTitle">
							<h3 class="title">The Integrated <br class="mo">Performance <br class="mo">Marketing Company</h3>
							<div class="text">
								GnM performance는 퍼포먼스 마케팅을 수행하기 위한 일원화된 기능과 <br>
								조직을 바탕으로 광고주의 성과를 극대화하기 위해 <br>
								Integrated Performance Marketing Service를 One Stop으로 제공합니다.
							</div>
						</div>
						<div class="visionBox">
							<span class="tit">One Stop</span>
							<ul class="visionList">
								<li class="no1">
									<img src="@/assets/images/oneStopImg01.png" alt="">
									<span>검색마케팅</span>
								</li>
								<li class="no2">
									<img src="@/assets/images/oneStopImg02.png" alt="">
									<span>퍼포먼스 광고</span>
								</li>
								<li class="no3">
									<img src="@/assets/images/oneStopImg03.png" alt="">
									<span>퍼포먼스 소셜 마케팅</span>
								</li>
								<li class="no4">
									<img src="@/assets/images/oneStopImg04.png" alt="">
									<span>미디어 플랫폼 서비스</span>
								</li>
							</ul>
						</div>
					</div>

				</div>
			</div>
			<!-- //section02 -->

			<!-- section03 -->
			<div class="section sec03" id="section03">
				<div class="contentWrap gnbGo">

					<Slick class="featureSlide" ref="slick" :options="slickOptions" v-if="$device.windows">
						<Feature1></Feature1>
						<Feature2></Feature2>
						<Feature3></Feature3>
						<Feature4></Feature4>
						<Feature5></Feature5>
						<Feature6></Feature6>
					</Slick>
					<div class="mo mofeatureWrap">
						<ul class="moFeatureList">
							<li class="no1" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:0})"><a href="#;">Feature</a></li>
							<li class="no2" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:1})"><a href="#;">Integrated Service</a></li>
							<li class="no3" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:2})"><a href="#;">Planning</a></li>
							<li class="no4" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:3})"><a href="#;">Creative - P E D</a></li>
							<li class="no5" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:4})"><a href="#;">Infra</a></li>
							<li class="no6" @click="fnDigGoToSlick({dataTarget:'popOpen',ref:'digSlick',index:5})"><a href="#;">Media Platform</a></li>
						</ul>
					</div>
					

				</div>
			</div>
			<!-- //section03 -->

			<!-- section04 -->
			<div class="section sec04" id="section04">
				<div class="contentWrap">

					<div class="clientWrap gnbGo">

						<div class="clientTitle">
							<h3 class="title">
								GnM performance는 <br class="mo">다양한 업종의 클라이언트사와 <br class="mo">함께 <br>
								퍼포먼스 마케팅을 <br class="mo">진행하고 있습니다
							</h3>
							<div class="text">
								통합 퍼포먼스 전략 하에서  미디어믹스에 따른  크리에이티브믹스를 완성할 수 있는 조직적 인프라 구축, <br>
								종합광고대행사의 인프라를 구축하고 있는 GnM performance만의 차별화 요소입니다.
							</div>
						</div>

						<Slick class="clientSlide" ref="slick" :options="slickOptions2" v-if="$device.windows">
							<Client1></Client1>
							<Client2></Client2>
							<Client3></Client3>
							<Client4></Client4>
							<Client5></Client5>
							<Client6></Client6>
						</Slick>

						<div class="mo moClientWrap">
							<span class="tit">Clients</span>
							<div class="img">
								<img src="@/assets/images/clientListImg.png" alt="클라이언트">
							</div>

							<div class="clientBox">
								<span class="tit">퍼포먼스 마케팅의 자세한 사례를 확인해 보세요</span>
								<ul class="moClientList">
									<li class="no1" @click="fnDigGoToSlick({dataTarget:'popOpenClient',ref:'clientSlick',index:0})"><a href="#;">홈쇼핑 앱마케팅 퍼포먼스 캠페인</a></li>
									<li class="no2" @click="fnDigGoToSlick({dataTarget:'popOpenClient',ref:'clientSlick',index:1})"><a href="#;">유통사 퍼포먼스 캠페인</a></li>
									<li class="no3" @click="fnDigGoToSlick({dataTarget:'popOpenClient',ref:'clientSlick',index:2})"><a href="#;">화재보험 장기보험 캠페인</a></li>
									<li class="no4" @click="fnDigGoToSlick({dataTarget:'popOpenClient',ref:'clientSlick',index:3})"><a href="#;">가상화폐 거래소 캠페인</a></li>
									<li class="no5" @click="fnDigGoToSlick({dataTarget:'popOpenClient',ref:'clientSlick',index:4})"><a href="#;">한방병원 장기운영 캠페인</a></li>
								</ul>
							</div>
						</div>

						

					</div>

				</div>
			</div>
			<!-- //section04 -->

			<!-- //section05 -->
			<div class="section sec05" id="section05">
				<div class="contentWrap gnbGo">

					<!-- recruitWrap r1 -->
					<div class="recruitWrap r1">

						<div class="recruitBox">

							<div class="recruitTitle">
								<h3 class="title">
									GnM Performance는 <br class="mo">함께 성장하고 키워나갈 <br>
									역량 있는 인재를 찾습니다
								</h3>
								<div class="subTitle">
									즐겁게 일할 수 있는 지엔앰퍼포먼스만의 <br class="mo">제도와 문화가 있습니다
								</div>
							</div>

							<div class="welfareList" v-if="$device.windows">
								<div class="wf1">
									<h4 class="title">건강한 문화</h4>
									<ul class="list">
										<li class="no1">
											<h5 class="tit">4대보험 적용</h5>
											<span class="txt">국민연금, 고용보험, 산재보험, 건강보험</span>
										</li>
										<li class="no2">
											<h5 class="tit">퇴직금 지급</h5>
										</li>
										<li class="no3">
											<h5 class="tit">종합 건강검진 지원</h5>
										</li>
									</ul>
								</div>
								<div class="wf2">
									<h4 class="title">즐거운 문화</h4>
									<ul class="list"> 
										<li class="no1">
											<h5 class="tit">각종 휴가 및 경조금 지원</h5>
											<span class="txt">경조금 지원, 연차휴가, 그랑프리휴가</span>
										</li>
										<li class="no2">
											<h5 class="tit">사내 동호회 운영 및 지원</h5>
										</li>
										<li class="no3">
											<h5 class="tit">패밀리데이/호프데이 실시</h5>
										</li>
										<li class="no4">
											<h5 class="tit">선택적 복리후생</h5>
											<span class="txt">복지몰 운영 및 복지포인트 지급</span>
										</li>
									</ul>
								</div>
								<div class="wf3">
									<h4 class="title">발전하는 문화</h4>
									<ul class="list">
										<li class="no1">
											<h5 class="tit">다양한 교육지원</h5>
											<span class="txt">온/오프라인 교육 및 세미나 참여 지원</span>
										</li>
										<li class="no2">
											<h5 class="tit">다양한 복리후생 지원</h5>
											<span class="txt">통신비, 문화비, 명절선물, 워크샵</span>
										</li>
									</ul>
								</div>
							</div>

							<Slick class="moWelfareList" ref="slick" :options="slickOptions3" v-if="!$device.windows">
								<div class="wf wf1">
									<h4 class="title">건강한 문화</h4>
									<ul class="list">
										<li class="no1">
											<h5 class="tit">4대보험 적용</h5>
											<span class="txt">국민연금, 고용보험, 산재보험, 건강보험</span>
										</li>
										<li class="no2">
											<h5 class="tit">퇴직금 지급</h5>
										</li>
										<li class="no3">
											<h5 class="tit">종합 건강검진 지원</h5>
										</li>
									</ul>
								</div>
								<div class="wf wf2">
									<h4 class="title">즐거운 문화</h4>
									<ul class="list"> 
										<li class="no1">
											<h5 class="tit">각종 휴가 및 경조금 지원</h5>
											<span class="txt">경조금 지원, 연차휴가, 그랑프리휴가</span>
										</li>
										<li class="no2">
											<h5 class="tit">사내 동호회 운영 및 지원</h5>
										</li>
										<li class="no3">
											<h5 class="tit">패밀리데이/호프데이 실시</h5>
										</li>
										<li class="no4">
											<h5 class="tit">선택적 복리후생</h5>
											<span class="txt">복지몰 운영 및 복지포인트 지급</span>
										</li>
									</ul>
								</div>
								<div class="wf wf3">
									<h4 class="title">발전하는 문화</h4>
									<ul class="list">
										<li class="no1">
											<h5 class="tit">다양한 교육지원</h5>
											<span class="txt">온/오프라인 교육 및 세미나 참여 지원</span>
										</li>
										<li class="no2">
											<h5 class="tit">다양한 복리후생 지원</h5>
											<span class="txt">통신비, 문화비, 명절선물, 워크샵</span>
										</li>
									</ul>
								</div>
							</Slick>

						</div>

					</div>
					<!-- //recruitWrap r1 -->

					<!-- recruitWrap r2 -->
					<div class="recruitWrap r2">
						<div class="recruitBox">
							<table class="table">
								<colgroup>
									<col width="280px">
									<col width="812px">
								</colgroup>
								<tbody>
									<tr class="one">
										<th>
											다양한 분야에서<br>
											인재를 찾습니다
										</th>
										<td>
											<ul class="recruitList">
												<li class="no1"><a href="#;" @click="popRecruit1 = true">마케팅 부문</a></li>
												<li class="no2"><a href="#;" @click="popRecruit2 = true">마케팅지원 부문</a></li>
												<li class="no3"><a href="#;" @click="popRecruit3 = true">제작 부문</a></li>
												<li class="no5"><a href="#;" @click="popRecruit5 = true">게임사업 부문</a></li>
												<li class="no4"><a href="#;" @click="popRecruit4 = true">경영지원 부문</a></li>
											</ul>
										</td>
									</tr>
									<tr class="two">
										<th>채용절차</th>
										<td>
											<ul class="recruitList" v-if="$device.windows">
												<li class="step1">
													<span class="num">01</span>
													<span>서류전형</span>
												</li>
												<li class="step2">
													<span class="num">02</span>
													<span>실무자 면접</span>
												</li>
												<li class="step3">
													<span class="num">03</span>
													<span>임원 면접</span>
												</li>
												<li class="step4">
													<span class="num">04</span>
													<span>최종 합격</span>
												</li>
											</ul>
											<img src="@/assets/images/recruitStep_mo.png" v-if="!$device.windows">
										</td>
									</tr>
									<tr class="three">
										<th>제출서류</th>
										<td> 
											<ul class="recruitList">
												<li>이력서 및 자기소개서(자유양식)</li>
												<li>포트폴리오(해당자)-목록,참여도,참여부분 상세히 기술</li>
												<li>기타 추가제출 서류는 입사확정 시 개별 안내</li>
												<li>채용 관련문의 : <a href="mailto:ad@gnmpm.com">ad@gnmpm.com</a> / <br class="mob">02-2015-2600</li>
											</ul>
										</td>
									</tr>
									<tr class="four">
										<th>근무조건</th>
										<td>
											<ul class="recruitList">
												<li>고용형태 : 경력/신입 (수습기간 3개월 적용)</li>
												<li>근무기간 : 주5일(월~금) / 10:00~19:00</li>
												<li>급여 : 회사 내규에 따름</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<!-- //recruitWrap r2 -->

					<RecruitPop1 v-if="popRecruit1" @close="popRecruit1 = false" />
					<RecruitPop2 v-if="popRecruit2" @close="popRecruit2 = false" />
					<RecruitPop3 v-if="popRecruit3" @close="popRecruit3 = false" />
					<RecruitPop4 v-if="popRecruit4" @close="popRecruit4 = false" />
					<RecruitPop5 v-if="popRecruit5" @close="popRecruit5 = false" />

				</div>
			</div>
			<!-- //section05 -->

<!-- ir 
<div id="ir"  class="section sec07">
<div class="boardWrap gnbGo">
	<div class="irTitle">
		IR
	</div>

	<div class="listCont">
		<table class="table_set">
				<caption>IR공지사항</caption>
				<colgroup>
					<col >
					<col style="width:150px;" >
				</colgroup>
				<thead>
					<tr>
						<th>제목</th>
						<th class="date_cell">등록일</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td><a href="?viewBoard=1#ir">채권자 이의 제출 공고문</a></td>
						<td class="date_cell">2021-05-27</td>
					</tr>
				</tbody>
		</table>
		<div class="paging">
			<a class="active" href="javascript:void(0)">1</a>
		</div>
	</div>

	<div class="viewCont">
		<div class="tabView">
			<div class="view">
				<div class="top_con">
					<p class="title">채권자 이의 제출 공고문</p>
				</div>
				<div class="bot_con">
					당사와 당사의 100% 자회사인 ㈜그랑플레이스, ㈜더블트리인터랙티브 및 ㈜에이마케팅(이하 총칭하여 “소멸회사”)은 각각 2021년 5월 27일 주주총회를 개최하여 상법 제522조에 따라 당사가 소멸회사를 흡수합병하고, 소멸회사는 해산하기로 결의하였습니다.
					당사는 위 합병으로 인하여 상법 제530조 및 제235조에 따라 소멸회사의 권리 및 의무를 포괄적으로 승계하게 되는 바, 상법 제527조의5에 따른 채권자 이의 제출을 당사 정관에 따라 아래와 같이 당사 홈페이지에 공고합니다.당사는 본 합병 이후에도 계속하여 기존 수행하던 사업을 동일하게 수행할 것이며, 채권자의 권리 등에 영향이 없을 것임을 확인합니다. 본 합병에 이의가 있으신 채권자는 아래 기간 내에 서면으로 이의를 제출하여 주시기 바랍니다. <br /><br />
					<div class="inner01">
					1.	제출자: ㈜ 지엔앰퍼포먼스에 대하여 채권을 보유하고 계신 채권자<br />
					2.	이의제출 기간: 2021년 5월 28일 ~ 2021년 6월 29일<br />
					3.	이의제출 방법 및 장소:<br />
						<div class="inner02">
							가.	제출방법: ㈜지엔앰퍼포먼스 [경영관리본부]에 서면(관련 계약서 등 증빙 포함)으로 제출<br />
							나.	제출처: 서울특별시 강남구 삼성로 511, 16층(삼성동, 골든타워) 소재 경영관리본부<br />
							<div class="inner03">(전화번호: [ 02-2015-2606 ])</div>
						</div>
					</div>

					<br /><br />

					상기 제출기한 종료시까지 이의를 제출하지 아니한 때에는 상법 제527조의5 및 제232조 제2항에따라 본 합병을 승인하는 것으로 간주됩니다.<br /><br />


					<div class="center">
						<div class="mark">
							<p>	
								2021년 5월 27일<br />

								주식회사 지엔앰퍼포먼스<br />

								공동대표이사: 임성훈, 노희종 (인)
							</p>
							<img src="@/assets/images/mark_gnm2.png" alt="도장">

						</div>
					</div>

				</div>
			</div>
			<div class="view">
				<div class="top_con">
					<p class="title">임시 2번째 글</p>
				</div>
				<div class="bot_con">
					임시 2번째 글
				</div>
			</div>
		</div>

		<div class="btn_wrap">
			<a href="javascript:void(0)" class="link_btn btn_list">목록</a>
		</div>
	</div>

</div>

</div>
 //ir -->

			<!-- //section06 -->
			<div class="section sec06" id="section06">
				<div class="contentWrap gnbGo">

					<div class="contactWrap">

						<div class="contactTitle">

							<h3 class="title">Contact us</h3>
							<div class="text">
								GnM performance의 통합 퍼포먼스 서비스를 통한 성공적인 마케팅과 최고의 성과를 달성해 보세요!
							</div>

						</div>

						<form id="fileUploadForm">
							<input type="hidden" id="event_type" name="event_type" v-model="event_type">
							<input placeholder="회사명" type="text" id="userCompany" name="USER_COMPANY" v-model="mem_company" value="" data-params='{"required" : true}' maxlength="25">
							<input placeholder="담당자" type="text" id="userNm" name="USER_NAME" v-model="mem_nm" value="" data-params='{"required" : true}' maxlength="25">

							<input placeholder="연락처" type="tel" id="userHp" name="USER_HP" v-model="usr_hp" data-params='{"ime" : "tel", "required" : true}'  maxlength="11">

							<input placeholder="이메일" id="userEmail" type="email" name="USER_EMAIL_ID" v-model="mem_email_id" data-params='{"ime" : "email", "required" : true}' value="" maxlength="50">


							<!--<input placeholder="USER_EMAIL_DOMAIN" type="email" name="USER_EMAIL_DOMAIN" data-params='{"ime" : "emailBack", "required" : true}' class="mailform" value="" v-model="mem_email_domain">


							<select class="select" id="userEmailLast" onchange="$('.mailform').val(this.value)">

								<option value="">직접입력</option>
								<option value="naver.com">naver.com</option>
								<option value="nate.com">nate.com</option>
								<option value="gmail.com">gmail.com</option>
								<option value="paran.com">paran.com</option>
								<option value="hanmail.net">hanmail.net</option>
								<option value="daum.net">daum.net</option>
								<option value="yahoo.co.kr">yahoo.co.kr</option>
								<option value="dreamwiz.com">dreamwiz.com</option>
								<option value="lycos.co.kr">lycos.co.kr</option>
								<option value="empal.com">empal.com</option>
								<option value="korea.com">korea.com</option>
								<option value="hanmir.com">hanmir.com</option>
								<option value="hotmail.com">hotmail.com</option>
								<option value="yahoo.com">yahoo.com</option>
							</select>-->
								<!-- <textarea placeholder="문의내용" id="userReason" name="USER_REASON" @keyup="fnKey" :maxlength="maxlength" class="textarea-scrollbar scrollbar-outer" value="" data-params='{"required" : true}'></textarea> -->
								<div id="demo">
									<section id="examples" class="textarea-example">
										
										<!-- content -->
										<div id="content-1" class="content">
												<!-- wrap textarea in a .textarea-wrapper div -->
												<div class="textarea-wrapper">
													<textarea placeholder="문의내용" id="userReason" name="USER_REASON" v-model="compModelTextarea" :maxlength="maxlength" class="textarea-scrollbar scrollbar-outer" value="" data-params='{"required" : true}'></textarea>
													<!-- add an extra .textarea-clone div -->
													<div class="textarea-clone"></div>
												</div>
										</div>
										
									</section>
								</div>
							
								

							<div class="fileWrap">
								<div class="tit">첨부파일</div>
								<input class="fileName" disabled="disabled" v-bind:value="fileName">
								<input id="fileUpload" type="file" name="file" size="20" v-on:change="fileUpload($event)" />
								<label for="fileUpload" class="btn">파일 선택</label>
							</div>
							
							<a href="javascript:void(0);" onclick="reg_contact()" class="btnContact">메일 보내기</a>
						</form>

					</div>

				</div>
			</div>
			<!-- //section06 -->

			<!-- //footer -->
			<footer class="foot">
				<div class="copyright">
					<h4 class="title">GnM performance</h4>
					<span class="text">Copyright© 2020 지엔앰퍼포먼스. All Rights Reserved.</span>
				</div>
				<div class="familySite">
					<select @change="fnSitemap">
						<option value="">Family Site</option>
						<option value="http://www.gmonster.co.kr">그랑몬스터</option>
						<option value="http://www.makeulike.com/new">메큐라이크</option>
						<option value="http://www.dtcompany.co.kr">더블트리</option>
						<option value="http://www.granpl.co.kr/">그랑플레이스</option>
						<option value="http://www.amarketing.co.kr">에이마케팅</option>
					</select>
				</div>
			</footer>
			<!-- //footer -->
			
		</div>


	

	</div>

	<MobilePop v-if="!$device.windows && popOpen" @event_bus="popOpen = false" class="digSlick">
		<Slick class="mo featureSlide" ref="digSlick" :options="slickOptions" >
			<Feature1 @slick_next="fnDigGoToSlick({ref:'digSlick',index:1})"></Feature1>
			<Feature2 @slick_next="fnDigGoToSlick({ref:'digSlick',index:2})"></Feature2>
			<Feature3 @slick_next="fnDigGoToSlick({ref:'digSlick',index:3})"></Feature3>
			<Feature4 @slick_next="fnDigGoToSlick({ref:'digSlick',index:4})"></Feature4>
			<Feature5 @slick_next="fnDigGoToSlick({ref:'digSlick',index:5})"></Feature5>
			<Feature6 @slick_next="fnDigGoToSlick({ref:'digSlick',index:6})"></Feature6>
		</Slick>
	</MobilePop>
	<MobilePop v-if="!$device.windows && popOpenClient" @event_bus="popOpenClient = false" class="clientSlick">
		<Slick class="mo clientSlide" ref="clientSlick" :options="slickOptions">
			<Client2 @slick_next="fnDigGoToSlick({ref:'clientSlick',index:1})"></Client2>
			<Client3 @slick_next="fnDigGoToSlick({ref:'clientSlick',index:2})"></Client3>
			<Client4 @slick_next="fnDigGoToSlick({ref:'clientSlick',index:3})"></Client4>
			<Client5 @slick_next="fnDigGoToSlick({ref:'clientSlick',index:4})"></Client5>
			<Client6 @slick_next="fnDigGoToSlick({ref:'clientSlick',index:5})"></Client6>
		</Slick>
	</MobilePop>
	<resize-observer @notify="handleResize" />




</div>
</template>

<script>
var flag = 0;
var p_uid = 0;
import { log } from 'util';
import Feature1 from '@/components/Feature1'
import Feature2 from '@/components/Feature2'
import Feature3 from '@/components/Feature3'
import Feature4 from '@/components/Feature4'
import Feature5 from '@/components/Feature5'
import Feature6 from '@/components/Feature6'
import Client1 from '@/components/Client1'
import Client2 from '@/components/Client2'
import Client3 from '@/components/Client3'
import Client4 from '@/components/Client4'
import Client5 from '@/components/Client5'
import Client6 from '@/components/Client6'
import MobilePop from '@/components/MobilePop'
import RecruitPop1 from '@/components/RecruitPop1'
import RecruitPop2 from '@/components/RecruitPop2'
import RecruitPop3 from '@/components/RecruitPop3'
import RecruitPop4 from '@/components/RecruitPop4'
import RecruitPop5 from '@/components/RecruitPop5'
export default {
	name: 'app',
	data() {
		return {
			maxlength:1000,
			mem_nm: '',
			usr_hp: '',
			mem_reason: '',
			mem_company: '',
			mem_email_id: '',
			mem_email_domain: '',
			event_type: 'contact',
			isScrollStop: true,
			slickOptions2: {
				slidesToShow: 1,
				arrows: false,
				dots: true,
				customPaging : function(slider, i) { 
					var clientDot = ['Clients', '홈쇼핑 앱마케팅 퍼포먼스 캠페인', '유통사 퍼포먼스 캠페인', '화재보험 장기보험 캠페인', '가상화폐 거래소 캠페인', '한방병원 장기운영 캠페인'];
					return clientDot[i];
				},
				fade: true,
				speed: 0
			},
			slickOptions3: {
				centerMode: true,
				centerPadding: '22px',
				arrows: false,
				dots: true,
			},
			fileName: '',
			popOpen:false,
			popOpenClient:false,
			modelTextarea:'',
			popRecruit1: false,
			popRecruit2: false,
			popRecruit3: false,
			popRecruit4: false,
			popRecruit5: false,
		}
	},
	computed: {
		slickOptions(){
			let o = {
				slidesToShow: 1,
				dots: true,
			}
			return this.$device.windows ? o : {...o, ...{
				adaptiveHeight: true,
				dots:false,
				fade:true,
				speed: 0,
				draggable: false,
				swipe: false,
			}}
		},
		compModelTextarea:{
			get(){
				if(this.modelTextarea.length == this.maxlength) {
					alert(`${this.maxlength}자까지만 입력가능합니다`)
				}
				return this.modelTextarea.slice(0,this.maxlength)
			},
			set(val){
				this.modelTextarea = val
			}
		}
	},
	created() {
		$(window).scroll(function(){
			var wWidth = $('.head').height();

			$('.section').find('.gnbGo').each(function(idx, item) {
				if($(window).scrollTop() > ($(this).offset().top * 0.6)){
					$(this).parents('.section').addClass('current');
				}
				if($(window).scrollTop() > ($('.recruitWrap.r2 .recruitBox .table').offset().top * 0.62)){
					$('.recruitWrap.r2').addClass('current2');
				}
				if($(window).scrollTop() > ($('#section06').offset().top * 0.8)){
					$('#section06').addClass('current2');
				}

				if($(window).scrollTop() > ($(this).offset().top - (wWidth * 2))){
					$('.head .navList .gnb li').removeClass('active')
					$('.head .navList .gnb li').eq(idx).addClass('active')
				}
			});
		});
	},
	mounted(){
		$('#fileUploadForm').cmmValidator()
		$(window).on("load",function(){

		//IR
		$(function(){

			//뷰보기
			function showView(){
				$('.boardWrap .listCont').hide();
				$('.boardWrap .viewCont').show();
			}

			//리스트 보기
			function showList(){
				$('.boardWrap .listCont').show();
				$('.boardWrap .viewCont').hide();
			}

			//뷰 내용 보기
			function showContent(){
				$('.tabView .view').eq(location.search.match(/viewBoard=([^&]*)/i)[1] -1).show().siblings().hide();
			}

			//뷰 바로가기
			$('.table_set tbody a').on('click',function(e){
				e.preventDefault();
				var fakeHref = $(this).attr('href');
				showView();
				history.pushState(null, null, fakeHref);

				//뷰 인덱스로 체크하여 노출
				showContent();

			})

			//리스트 바로가기
			$('.link_btn').on('click',function(e){
				showList();
				history.pushState(null, null, '?list#ir');
				$(window).scrollTop($('#ir').offset().top);
			});
			
			//초기 view 진입 체크
			try{
				if(location.search.match(/viewBoard=([^&]*)/i)[1]){
					showView();
					showContent();
				}
			}catch(error){
				//console.log(error)
			}

			window.onpopstate = function(event) {
				if(!getParameterByName('viewBoard')){
					showList();
				}else{
					if(location.search.match(/viewBoard=([^&]*)/i)[1]){
						showView();
						showContent();
					}
				}
			};

			//팝업에서 이동
			$('.popArea .moveIr').on('click',function(e){
				$('html,body').animate({scrollTop:$('#ir').offset().top},500);
				$('.table_set a').trigger('click');
			});
			
			//팝업닫기
			$('.popArea .close').on('click',function(e){
				$('.popArea').fadeOut('fast')
			});

		})
		//IR




		function getParameterByName(name) {
			var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
			return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
		}



				var textareaLineHeight=parseInt($(".textarea-wrapper textarea").css("line-height"));
				
				$(".textarea-wrapper").mCustomScrollbar({
					scrollInertia:0,
					theme:"dark-3",
					advanced:{autoScrollOnFocus:false},
					mouseWheel:{disableOver:["select","option","keygen","datalist",""]},
					keyboard:{enable:false},
					//snapAmount:textareaLineHeight
				});
				
				var textarea=$(".textarea-wrapper textarea"),textareaWrapper=$(".textarea-wrapper"),textareaClone=$(".textarea-wrapper .textarea-clone");
				
				textarea.bind("keyup keydown",function(e){
        			var $this=$(this),textareaContent=$this.val(),clength=textareaContent.length,cursorPosition=textarea.getCursorPosition();
					textareaContent="<span>"+textareaContent.substr(0,cursorPosition)+"</span>"+textareaContent.substr(cursorPosition,textareaContent.length);
					textareaContent=textareaContent.replace(/\n/g,"<br />");
        			textareaClone.html(textareaContent+"<br />");
        			$this.css("height",textareaClone.height());
					var textareaCloneSpan=textareaClone.children("span"),textareaCloneSpanOffset=0,
						viewLimitBottom=(parseInt(textareaClone.css("min-height")))-textareaCloneSpanOffset,viewLimitTop=textareaCloneSpanOffset,
						viewRatio=Math.round(textareaCloneSpan.height()+textareaWrapper.find(".mCSB_container").position().top);
					if(viewRatio>viewLimitBottom || viewRatio<viewLimitTop){
						if((textareaCloneSpan.height()-textareaCloneSpanOffset)>0){
							textareaWrapper.mCustomScrollbar("scrollTo",textareaCloneSpan.height()-textareaCloneSpanOffset-textareaLineHeight);
						}else{
							textareaWrapper.mCustomScrollbar("scrollTo","top");
						}
					}
    			});
    			
    			$.fn.getCursorPosition=function(){
        			var el=$(this).get(0),pos=0;
        			if("selectionStart" in el){
            			pos=el.selectionStart;
        			}else if("selection" in document){
            			el.focus();
            			var sel=document.selection.createRange(),selLength=document.selection.createRange().text.length;
            			sel.moveStart("character",-el.value.length);
            			pos=sel.text.length-selLength;
        			}
        			return pos;
    			}
				
			});
			
			var clearInterval;
		setInterval(function(){
			$('.sqList li.no2').addClass('active');
			clearInterval = setTimeout(function(){
				$('.sqList li.no2').removeClass('active');
				clearTimeout(clearInterval);
			},1000);
		},1000)
						
		setInterval(function(){
			$('.sqList li.no3').addClass('active');
			clearInterval = setTimeout(function(){
				$('.sqList li.no3').removeClass('active');
				clearTimeout(clearInterval);
			},1700);
		},1700)
	},
	methods: {
		fnKey(event){
			let l = this.maxlength
			let v = event.target.value
			if(v.length >= l){
				alert(`${l}자까지만 입력가능합니다`)
			}
		},
		fnDigGoToSlick({...o}){
			$('.digPop .digPopInner .digPopCont').scrollTop(0)
			this.fnSlickPromise({
				target : o.dataTarget,
				bool : true,
			}).then(res=>{
				this.$refs[o.ref].goTo(o.index,0)
			})
		},
		fnSlickPromise({...o}){
			if(o.target){
				this[o.target] = o.bool
			}
			return new Promise(resolv=>{
				resolv()
			})
		},
		handleResize() {
		},
		menuToggle() {
			$('.mo.navList').toggleClass('open')
			$('body').toggleClass('open');
			if($('.mo.navList').is('.open')){
				$('.mo.navList').css('min-height' , window.innerHeight)
			}
		},
		go(idx) {
			var scTop = $('.sec0' + idx).find('.gnbGo').offset().top;
			var wWidth = $('.head').height();
			
			if(idx > 1){
				scTop = scTop - wWidth
			}

			if($('.navList').hasClass('mo')){
				$('.mo.navList').removeClass('open');
				$('body').removeClass('open');

				setTimeout(function(){ 
					$('html, body').stop().animate({
						scrollTop : scTop,
						duration: 500
					},500);
				}, 350);
			} else {
				$('html, body').stop().animate({
					scrollTop : scTop,
					duration: 500
				},500)
			}

			$('.gnb li').removeClass('active');
			$('.gnb li').eq(idx - 1).addClass('active');
			
		},fileUpload(event) {
			// return this.fileName = event.target.files[0].name
			return this.fileName = event.target.value
		},
		fnSitemap(event){
			let e = event.target.value
			if(e){
				window.open(e,'_blank')
			}
		},
	},
	components:{
		Feature1,
		Feature2,
		Feature3,
		Feature4,
		Feature5,
		Feature6,
		Client1,
		Client2,
		Client3,
		Client4,
		Client5,
		Client6,
		MobilePop,
		RecruitPop1,
		RecruitPop2,
		RecruitPop3,
		RecruitPop4,
		RecruitPop5
	}
}
</script>
